<div class="tab-content-container mt-3 mb-2">
    <h4 class="border-bottom">History</h4>
    @if (gridConfig) {
    <div class="history-tab-grid" [style.height.px]="gridHeight">
        <inavista-grid #historyTabGrid class="so-popup-grid"
            [config]="gridConfig"
            (exportRequested)="onExportRequested()" />
    </div>
    }
</div>
